const isLive = document.querySelector('.-live');

if (isLive) {
    const teaserBoxEls = document.querySelectorAll('.neos-contentcollection .teaser-boxes__item');
    const imagesTeaserEls = document.querySelectorAll('.neos-contentcollection .images-teaser__container');
    const headlineEls = document.querySelectorAll('.neos-contentcollection .headline');
    const textEls = document.querySelectorAll('.neos-contentcollection .text-container .text');
    const textWithImageEls = document.querySelectorAll(
        '.neos-contentcollection .text-with-image .image, .neos-contentcollection .text-with-image h2'
    );
    const textWithImageTextEls = document.querySelectorAll(
        '.neos-contentcollection .text-with-image .text > *:not(h2)'
    );
    const logoGroupEls = document.querySelectorAll('.neos-contentcollection .logo-group');
    const videoWithHeadlineEls = document.querySelectorAll(
        '.neos-contentcollection .video-with-headline__headline, .neos-contentcollection .video-with-headline__video-container'
    );
    const mapEls = document.querySelectorAll(
        '.neos-contentcollection .map__map, .neos-contentcollection .map__info-item, .neos-contentcollection .map__headline'
    );
    const featuresTeaserHeadlineEls = document.querySelectorAll('.neos-contentcollection .features-teaser__headline');
    const featuresTeaserBoxesEls = document.querySelectorAll('.neos-contentcollection .features-teaser__boxes');
    const featuresItemEls = document.querySelectorAll('.neos-contentcollection .features__items .feature');
    const threeColumnTextHeadlineEls = document.querySelectorAll(
        '.neos-contentcollection .three-column-text__headline'
    );
    const threeColumnTextItemEls = document.querySelectorAll(
        '.neos-contentcollection .three-column-text__container .column-text'
    );
    const floorFamilyOverviewHeadlineEls = document.querySelectorAll(
        '.neos-contentcollection .floor-family-overview__headline'
    );
    const floorFamilyOverviewBoxEls = document.querySelectorAll('.neos-contentcollection .floor-family-box');
    const decorOverviewHeadlineEls = document.querySelectorAll('.neos-contentcollection .decor-overview__headline');
    const decorOverviewBoxEls = document.querySelectorAll('.neos-contentcollection .decor-box');
    const faqHeadlineEls = document.querySelectorAll('.neos-contentcollection .faq__headline');
    const faqQuestionEls = document.querySelectorAll('.neos-contentcollection .faq-question');
    const contentTeaserEls = document.querySelectorAll(
        '.neos-contentcollection .content-teaser__image, .neos-contentcollection .content-teaser__headline, .neos-contentcollection .content-teaser__text, .neos-contentcollection .content-teaser__button'
    );
    const withinImageSliderImageEls = document.querySelectorAll('.neos-contentcollection .within-image-slider__image');
    const footerEls = document.querySelectorAll('.footer');
    const searchItemEls = document.querySelectorAll(' .detail-search__results-item');
    const searchEls = document.querySelectorAll('.detail-search__results-count, .detail-search__form');
    const counselorEls = document.querySelectorAll('.counselor-content__back-to-overview-link--bottom');
    const highlightBoxEls = document.querySelectorAll('.highlight-box');
    const borderBoxEls = document.querySelectorAll('.border-box');
    const textWithImageInstructionEls = document.querySelectorAll('.text-with-image-instruction');

    const slideInObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animation-slide-in--fired');
                    setTimeout(() => {
                        entry.target.classList.remove('animation-slide-in');
                        entry.target.classList.remove('animation-slide-in--fired');
                    }, 600);
                    slideInObserver.unobserve(entry.target);
                }
            });
        },
        { rootMargin: '0px 0px -150px 0px' }
    );

    const fadeInObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animation-fade-in--fired');
                    fadeInObserver.unobserve(entry.target);
                    setTimeout(() => {
                        entry.target.classList.remove('animation-fade-in');
                        entry.target.classList.remove('animation-fade-in--fired');
                    }, 600);
                }
            });
        },
        { rootMargin: '0px 0px -150px 0px' }
    );

    const slideInEls = [
        ...teaserBoxEls,
        ...textEls,
        ...featuresTeaserBoxesEls,
        ...featuresItemEls,
        ...threeColumnTextItemEls,
        ...floorFamilyOverviewBoxEls,
        ...mapEls,
        ...decorOverviewBoxEls,
        ...faqQuestionEls,
        ...contentTeaserEls,
        ...footerEls,
        ...textWithImageTextEls,
        ...searchItemEls,
        ...counselorEls,
        ...highlightBoxEls,
        ...borderBoxEls,
        ...textWithImageInstructionEls,
    ];
    slideInEls.forEach((slideInEl) => {
        slideInEl.classList.add('animation-slide-in');
        slideInObserver.observe(slideInEl);
    });

    const fadeInEls = [
        ...imagesTeaserEls,
        ...textWithImageEls,
        ...logoGroupEls,
        ...videoWithHeadlineEls,
        ...headlineEls,
        ...featuresTeaserHeadlineEls,
        ...threeColumnTextHeadlineEls,
        ...floorFamilyOverviewHeadlineEls,
        ...decorOverviewHeadlineEls,
        ...faqHeadlineEls,
        ...withinImageSliderImageEls,
        ...searchEls,
    ];
    fadeInEls.forEach((fadeInEl) => {
        fadeInEl.classList.add('animation-fade-in');
        fadeInObserver.observe(fadeInEl);
    });
}
